<template>
  <ul-page full class="page-login">
    <template v-slot:right>
      <div class="page-header-right">
        <span @click="getHelp">联系客服</span>
        <span @click="toHome">网站首页</span>
      </div>
    </template>
    <div class="banner"></div>
    <div class="mobile-logo">
      <img src="@/assets/images/logo.png" alt="">
    </div>
    <Login ref="login" v-show="mode == 1">
      <div class="register register-mobile">
        <a href="javascript:;" @click="toRegister">去注册</a>
        <a href="javascript:;" @click="toFindPwd">忘记密码？</a>
      </div>
      <ul-button class="btn-submit" type="primary" @click="login">登录</ul-button>
      <div class="register register-pc">
        <a href="javascript:;" @click="toRegister">去注册</a>
        <a href="javascript:;" @click="toFindPwd">忘记密码？</a>
      </div>
      <div class="others-container">
        <div class="others-title">
          <div class="line">
            <div class="title">其他登录方式</div>
          </div>
        </div>
        <div class="others-wrapper">
          <div class="others-item" @click="mode = 2">
            <i class="iconfont icon-duanxin"></i>
            <div class="desc">短信登录</div>
          </div>
          <div class="others-item" @click="wxLogin" v-if="showWxLogin">
            <i class="iconfont icon-wechat"></i>
            <div class="desc">微信登录</div>
          </div>
          <!-- 暂时隐藏welink登录 -->
          <!-- <div class="others-item" @click="welinkLogin" v-if="showWelink">
            <img class="welink-icon" src="@/assets/images/welink.png" />
            <div class="desc">welink登录</div>
          </div> -->
        </div>
      </div>
    </Login>
    <div class="form-container" v-show="mode == 2">
      <div class="back" @click="cancelPhoneLogin">
        <i class="iconfont icon-zuoye"></i><span>返回</span>
      </div>
      <h1 class="form-title">短信登录</h1>
      <ul-form class="form-login" ref="loginFormPhone" :model="user" :rules="rulesPhone">
        <ul-form-item prop="cellphone" label-width="0">
          <ul-input v-model="user.cellphone" placeholder="请输入手机号">
            <template slot="prepend">+86</template>
          </ul-input>
        </ul-form-item>
        <ul-form-item class="form-item-code" prop="code" label-width="0" :error="phoneErrorMsg">
          <ul-input v-model="user.code" placeholder="请输入验证码"  @keydown.native.enter="loginPhone"></ul-input>
          <ul-button class="btn-code" disabled v-if="remaining > 0 && remaining < 60">重新获取({{remaining}})</ul-button>
          <ul-button class="btn-code" v-else :disabled="user.cellphone == ''" @click="getPhoneCode">获取验证码</ul-button>
        </ul-form-item>
        <div class="phone-tips">*短信登录仅支持中国大陆手机号</div>
        <ul-button class="btn-submit" type="primary" @click="loginPhone">登录</ul-button>
      </ul-form>
    </div>
    <div class="form-container" v-show="mode == 3">
      <div class="back" @click="cancelImageCode">
        <i class="iconfont icon-zuoye"></i><span>返回</span>
      </div>
      <h1 class="form-title">身份验证</h1>
      <div class="image-code-wrapper">
        <img :src="image.url" alt="" v-if="image.url">
      </div>
      <ul-form class="form-login" ref="loginFormImg">
        <ul-form-item prop="cellphone" label-width="0" :error="image.errorMsg">
          <ul-input v-model="image.code" placeholder="请输入验证码">
          </ul-input>
        </ul-form-item>
        <ul-button type="primary" class="btn-submit" @click="checkImageCode">确定</ul-button>
      </ul-form>
    </div>
    <template v-slot:footer>
      <div class="login-tips">登录即为同意优学院 <span>《用户协议》</span> 与 <span>《隐私政策》</span></div>
    </template>
    
  </ul-page>
</template>

<script>
import Login from 'pc/components/login.vue'
import User from '@/model/user.js'
import { device } from '@/utils/device.js'
import { getImgCode, checkSendsms } from '@/api/courseApi.js'
import { UMOOC_COOKIE_DOMAIN, WXPCLOGINAPPID, WXGZHAPPID } from '@/config'
import { mapGetters } from 'vuex'
import { wxLogin, welinkLogin } from '@/utils/index.js'
import cookies from '@/utils/cookie'
export default {
  name: 'login',
  components: {
    Login
  },
  data () {
    return {
      user: new User(),
      mode: 1,  // 1账号登录 2手机号登录 3图形验证码
      isSecurity: false,  // 是否开启登录保护
      errorMsg: '',  //账号密码登录不成功提示
      codeErrorMsg: '', // 登录保护验证码不正确提示
      phoneErrorMsg: '',  //电话验证码登录不正确提示
      image: {
        code: '', //图形验证码
        url: '', // 图形验证码图片链接
        errorMsg: '',
        verKey: '' //图形验证码key
      },
      remaining: 60, //倒计时剩余时间
      rules: {
        loginName: [
          { required: true, message: '请输入用户名/手机号/邮箱', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' }
        ],
        code: [
          { required: true, message: '请输入动态验证码', trigger: 'blur' }
        ]
      },
      rulesPhone: {
        cellphone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[0-9]{10}$/, message: '手机号格式错误', trigger: 'blur'}
        ],
        code: [
          { required: true, message: '请输入动态验证码', trigger: 'blur' }
        ]
      },
      showWxLogin: device.platform.weixin || !device.isMobile,
      showWelink: !device.isMobile
    }
  },
  created () {

  },
  mounted () {
    window.test = this
  },
  computed: {
    ...mapGetters({'account': 'user/user'})
  },
  methods: {
    wxLogin,
    welinkLogin,
    login () {
      this.$refs.login.login()
    },
    loginPhone () {
      this.phoneErrorMsg = ''
      this.$refs['loginFormPhone'].validate((valid, detail) => {
        if (valid) {
          if (this.isPhoneLogining) {
            return
          }
          this.isPhoneLogining = true
          this.user.checkcode()
            .then(data => {
              this.isPhoneLogining = false
              if (data.status == 1) {
                this.user.phoneLogin()
              } else {
                // this.$message({
                //   message: data.message,
                //   type: 'warning'
                // })
                this.phoneErrorMsg = data.message
              }
            })
            .catch(err => {
              this.isPhoneLogining = false
            })
        }
      })
    },
    cancelPhoneLogin () {
      this.user.cellphone = ''
      this.user.code = ''
      this.mode = 1
      this.$refs['loginFormPhone'].clearValidate()
    },
    cancelImageCode () {
      this.image.code  = ''
      this.mode = 2
    },
    getPhoneCode () {
      let errMsgs = []
      this.$refs['loginFormPhone'].validateField(['cellphone'], (err,detail) => {
        errMsgs.push(err)
      })
      if (errMsgs.every((item) => item === '')) {
        this.getImgCode()
      }
    },
    getImgCode () {
      getImgCode()
        .then(data => {
          this.mode = 3
          this.image.errorMsg = ''
          this.image.url = data.image
          this.image.verKey = data.verKey
        })
    },
    checkImageCode () {
      if (this.image.code == '') {
        this.image.errorMsg = '请输入验证码'
      } else {
        checkSendsms({
          captcha: this.image.code,
          cellphone: this.user.cellphone,
          regionCode: 86,
          verKey: this.image.verKey
        })
        .then(data => {
          if (data.status == 1) {
            this.mode = 2
            this.startTimer()
          } else {            
            this.image.errorMsg = data.message
          }
        })
      }
    },
    startTimer () {
      this.remaining = 59
      let timer = setInterval( () => {
        this.remaining--
        if (this.remaining == 0) {
          clearInterval(timer)
        }        
      }, 1000)
    },
    toRegister () {
      let url = 'https://umobile' + UMOOC_COOKIE_DOMAIN + '/#/user/register'
      // let url = 'http://localhost:8081/#/user/register'
      if (device.isMobile) {
        url = 'https://umobile' + UMOOC_COOKIE_DOMAIN + '/#/user/choseRegisterType'
      }
      location.href = url
    },
    toFindPwd () {
      // window.open('https://umobile' + UMOOC_COOKIE_DOMAIN + '/#/user/findPassword')
      location.href = 'https://umobile' + UMOOC_COOKIE_DOMAIN + '/#/user/findPassword'
    },
    toHome () {
      if (this.$route.query.domain == 'hnylkc') {
        window.location.href = `http://hnylkc${UMOOC_COOKIE_DOMAIN}`
      } else {
        window.location.href = `https://www${UMOOC_COOKIE_DOMAIN}`
      }
    },
    getHelp () {
      var config = {
        // uid: self.user.id(),
        // uname: self.user.name(),
        exterinfo: {
          url: encodeURI(window.location.href),
          userAgent: encodeURI(window.navigator.userAgent)
        },
        system: 'web'
      }
      if (this.account.userId) {
        config.userId = this.account.userId
        config.uname = this.account.name
      }
      xn('setCustomerInfo', config);
      xn('openChat', 'kf_20125_template_9999')
    }
  }
}
</script>

<style lang="scss" scoped>
.page-header-right{
  span{
    display: inline-block;
    padding: 0 12px;
    cursor: pointer;
    &:hover{
      color: $--color-primary;
    }
    &:not(:last-child) {
      border-right: $--border-base;
    }
  }
}
.banner{
  height: 160px;
  background-image: url(~@/assets/images/login_banner.png);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.mobile-logo{
  display: none;
}
::v-deep {
  .ul-page__body-content{
    background-color: inherit;
  }
}
.form-container{
  position: relative;
  width: 800px;
  margin: -90px auto 0;
  padding: 48px;
  background-color: $--color-white;
  border-radius: 4px;
  .form-title{
    margin: 0 0 32px;
    font-size: 30px;
    text-align: center;
    font-weight: normal;
  }
  .back {
    position: absolute;
    left: 20px;
    top: 20px;
    cursor: pointer;
    color: $--color-text-secondary;
    i{
      color: $--color-text-secondary;
      font-size: 14px;
    }
    &:hover{
      color: $--color-primary;
      i{
        color: $--color-primary;
      }
    }
  }
}
.form-login{
  width: 420px;
  margin: 0 auto;
  ::v-deep{
    .ul-input__inner{
      height: 44px;
      line-height: 44px;
    }
    .form-item-code{
      .ul-form-item__content{
        display: flex;
      }
      .ul-input{
        flex: 1;
        margin-right: 12px;
      }
    }
    .ul-input-group__prepend{
      background-color: $--color-white;
    }
  }
  .ul-button{
    padding: 14px 20px;
  }
  .phone-tips{
    color: $--color-text-secondary;
    font-size: 12px;
  }
}
.image-code-wrapper{
  text-align: center;
}
.btn-submit{
  margin-top: 18px;
  width: 100%;
}
.register{
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  a{
    color: $--color-text-base;
    &:hover{
      color: $--color-primary;
    }
  }
}
.register-pc{
  display: flex;
}
.register-mobile{
  display: none;
}
.others-title{
  .line{
    position: relative;
    height: 1px;
    margin-top: 32px;
    background-color: $--border-color-base;
    .title{
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #fff;
      padding: 0 9px;
      color: $--color-text-secondary;
    }
  }
}
.others-wrapper{
  display: flex;
  margin-top: 26px;
  justify-content: center;
  .others-item{
    padding: 0 26px;
    text-align: center;
    cursor: pointer;
    &:hover{
      .desc{
        color: $--color-primary;
      }
    }
    .welink-icon {
      display: block;
      margin: 0 auto;
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
  i{
    display: inline-block;
    border-radius: 100%;
    height: 40px;
    width: 40px;
    text-align: center;
    color: #fff;
    line-height: 40px;
    font-size: 16px;
  }
  .icon-duanxin{
    background: linear-gradient(180deg,#93ebff,#3bbfff);
  }
  .icon-wechat{
    background: linear-gradient(180deg,#59de8d,#63d493 98%);
  }
  .desc{
    margin-top: 8px;
    color: $--color-text-secondary;
  }
}
.login-tips{
  display: none;
}
@media (max-width: 768px) {
  .banner{
    display: none;
  }
  .mobile-logo{
    display: block;
    padding: 42px 0 16px 0;
    text-align: center;
    img{
      height: 40px;
    }
  }
  .form-container{
    position: initial;
    width: 100%;
    margin: 0;
    padding: 20px;
    .form-title{
      display: none;
    }
    .form-login{
      width: auto;
    }
  }
  .register-pc{
    display: none;
  }
  .register-mobile{
    display: flex;
  }
  .login-tips{
    display: block;
    margin-bottom: 12px;
    padding: 12px 0;
    text-align: center;
    font-size: 12px;
    span{
      color: $--color-primary;
    }
  }
}
</style>